import { RelatedFilesQueryParamsType } from '@/common/queries/relatedFiles/relatedFilesQuery.type.ts';
import { queryOptions } from '@tanstack/react-query';
import { relatedFilesQueryFunction } from '@/common/queries/relatedFiles/relatedFilesQueryFunction.ts';
import { showRelatedFilesDetailCardDataGenerator } from '@/common/data/relatedFiles/showRelatedFilesDetailCardDataGenerator.ts';
import { acceptRelatedFilesDetailCardDataGenerator } from '@/common/data/relatedFiles/acceptRelatedFilesDetailCardDataGenerator.ts';

export const relatedFilesQueryOption = ({ id }: RelatedFilesQueryParamsType) =>
  queryOptions({
    queryKey: ['related-files', id],
    queryFn: () => relatedFilesQueryFunction({ id }),
    select: (data) => ({
      relatedFiles: data,
      showDetailCardItems: showRelatedFilesDetailCardDataGenerator(data),
      acceptFileDetailCardItems:
        acceptRelatedFilesDetailCardDataGenerator(data),
    }),
  });
